import { render, staticRenderFns } from "./MiniLoveVerifyNumConfig.vue?vue&type=template&id=5ebd857c&scoped=true&"
import script from "./MiniLoveVerifyNumConfig.vue?vue&type=script&lang=js&"
export * from "./MiniLoveVerifyNumConfig.vue?vue&type=script&lang=js&"
import style0 from "./MiniLoveVerifyNumConfig.vue?vue&type=style&index=0&id=5ebd857c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebd857c",
  null
  
)

export default component.exports